export const ReleaseInfo = Object.freeze({
  releaseVersion: "2026.10.20-1321.15",
  commitId: "7c571f7d77d1b188f7307215f9a7b2fc04a9cdbc",
  commitTime: "2026-10-20T13:21:15.000Z",
});
